/**
 * @module router/modules/infra
 * @description 인프라 도메인 라우트 모듈 — 고객사, 제조사, 제품군, 모델, 부품 관리 페이지 경로를 정의합니다.
 *
 * SURINP-191 S7-3 (2026-04-29):
 * - 등록 팝업 라우트 4개 일괄 제거 (window.open 기반 → ModalPopup 통합):
 *   /service-company-register (infra-service-master 팀이 ServiceCompanyRegisterModal로 전환)
 *   /product-line-register    (ProductLineRegisterModal)
 *   /product-model-register   (ProductModelRegisterModal)
 *   /product-part-register    (ProductPartRegisterModal)
 */
const routes = [
  {
    path: '/service-company-management',
    // SURINP-316 후속: partner 도메인 그룹명('고객사 관리') 오차용 정정 — 직접 URL/탭 복원 시
    // tabs.js 가 route.name 을 fallback 표시하므로 화면 실체(인프라 관리 > 협력업체 관리)와 일치 필요
    name: '협력업체 관리',
    component: () => import(/* webpackChunkName: "serviceCompanyManagement" */ '../../views/infra/ServiceCompanyManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  {
    path: '/manufacturer-management',
    name: '제조사 관리',
    component: () => import(/* webpackChunkName: "manufacturerManagement" */ '../../views/infra/ManufacturerManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true, partnerSelect: true }
  },
  {
    path: '/product-line-management',
    name: '제품군 관리',
    component: () => import(/* webpackChunkName: "productLineManagement" */ '../../views/infra/ProductLineManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true, partnerSelect: true }
  },
  {
    path: '/product-model-management',
    name: '모델 관리',
    component: () => import(/* webpackChunkName: "productModelManagement" */ '../../views/infra/ProductModelManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true, partnerSelect: true }
  },
  {
    path: '/product-part-management',
    name: '부품 관리',
    component: () => import(/* webpackChunkName: "productPartManagement" */ '../../views/infra/ProductPartManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true, partnerSelect: true }
  }
]

export default routes
